// 货币
export const enum Currency {
  ID = 'IDR',
  MY = 'MYR',
  PH = 'PHP',
  TH = 'THB',
  VN = 'VND',
  SG = 'SGD',
  GB = 'GBP',
  US = 'USD',
  ES = 'EUR',
  MX = 'MXN',
  DE = 'EUR',
  IT = 'EUR',
  FR = 'EUR',
  BR = 'BRL',
  JP = 'JPY',
  GLOBAL = 'USD'
}

export function isValidCurrency(currency?: string): currency is Currency {
  if (currency === undefined) {
    return false
  }

  return (
    [
      Currency.ID,
      Currency.MY,
      Currency.PH,
      Currency.TH,
      Currency.VN,
      Currency.SG,
      Currency.GB,
      Currency.US,
      Currency.GLOBAL,
      Currency.ES,
      Currency.MX,
      Currency.DE,
      Currency.IT,
      Currency.FR,
      Currency.BR,
      Currency.JP
    ] as string[]
  ).includes(currency)
}

/** 辅助货币 */
export enum SecondaryCurrency {
  CN = 'CNY',
  US = 'USD',
  ID = 'IDR',
  MY = 'MYR',
  PH = 'PHP',
  TH = 'THB',
  VN = 'VND',
  SG = 'SGD',
  GB = 'GBP',
  ES = 'EUR',
  MX = 'MXN',
  BR = 'BRL',
  JP = 'JPY'
}

export const secondaryCurrencyMap = new Map([
  [SecondaryCurrency.CN, { sign: '¥', label: '人民币' }],
  [SecondaryCurrency.US, { sign: '$', label: '美元' }],
  [SecondaryCurrency.ID, { sign: 'Rp', label: '印尼盾' }],
  [SecondaryCurrency.MY, { sign: 'RM', label: '马来西亚林吉特' }],
  [SecondaryCurrency.PH, { sign: '₱', label: '菲律宾比索' }],
  [SecondaryCurrency.TH, { sign: '฿', label: '泰铢' }],
  [SecondaryCurrency.VN, { sign: '₫', label: '越南盾' }],
  [SecondaryCurrency.SG, { sign: 'S$', label: '新加坡元' }],
  [SecondaryCurrency.GB, { sign: '£', label: '英镑' }],
  [SecondaryCurrency.ES, { sign: '€', label: '欧元' }],
  [SecondaryCurrency.MX, { sign: 'MX$', label: '墨西哥比索' }],
  [SecondaryCurrency.BR, { sign: 'R$', label: '巴西雷亚尔' }],
  [SecondaryCurrency.JP, { sign: '¥', label: '日元' }]
])

export function isValidSecondaryCurrency(currency?: string): boolean {
  if (currency === undefined) {
    return false
  }
  return secondaryCurrencyMap.has(currency as SecondaryCurrency)
}
